import { Encoding, MarkTransform, MarkType } from '@mode-vegas/vegas';
import { EncodingHelpers } from '../..';
import { ChartTranslator } from '../chart-translator';

export class AreaTranslator implements ChartTranslator {
  translateHighChartsToMuze(encoding: Encoding): Encoding {
    // Set the transform to Stack
    encoding = EncodingHelpers.updateMarkOptions(encoding, {
      type: MarkType.Area,
      transform: MarkTransform.Stack,
    }).encoding;

    return encoding;
  }

  translateMuzeToHighCharts(encoding: Encoding): Encoding {
    return encoding;
  }

  formatRequiresEncodingUpdate(): boolean {
    return false;
  }
}
